export const WEBSITE = 'MYHEALTHBOOK';
